import script from "./ListadoCalificar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListadoCalificar.vue?vue&type=script&lang=ts&setup=true"

import "./ListadoCalificar.vue?vue&type=style&index=0&id=5fc0707b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc0707b"]])

export default __exports__